module.exports = __webpack_public_path__ + "img/acord1-2.e0ddda02.png";